import * as Yup from "yup";

export const ValidationSchema = Yup.object({
  firstName: Yup.string().trim().min(2, "Enter your first name").required("Please enter your first name"),
  lastName: Yup.string().trim().min(2, "Enter your last name").required("Please enter your last name"),
  phoneNumber: Yup.string()
    .matches(/^\d{11}$/, "Enter an 11-digit phone number")
    .required("Phone number is required"),
  email: Yup.string().email("Invalid email format").required("Email is required"),
  type: Yup.string().required("Choose a meter type"),
  phase: Yup.string().required("Choose a phase"),
  quantity: Yup.number()
    .typeError("Enter a quantity")
    .integer("Must be a whole number")
    .min(1, "At least 1")
    .required("Quantity is required"),
});
